import React from 'react';

import { SVGIcon } from 'UIKit/index';
import Forms from 'Assets/images/AppLogo/forms.svg';

const backgroundStyle = {
    backgroundImage: 'url(' + Forms + ')',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
};
export default function DCForms(props) {
    return <SVGIcon {...props} viewBox="0 0 2000 2000" style={backgroundStyle} />;
}
